export default __webpack_public_path__ + "static/media/leviathan.28943ab6.jpg";